import classNames from "classnames";
import { BookifullLogo } from "../BookifullLogo";
import Loader from "../Loader";
import { PublicLegalFooter } from "../legal/PublicLegalFooter";
import styles from "./AuthContainer.module.css";

interface Props {
  footerText?: React.ReactNode | string;
  showLogo?: boolean;
  heading?: string;
  loading?: boolean;
}

export default function AuthContainer(props: React.PropsWithChildren<Props>): React.ReactElement {
  return (
    <div className={styles.shell}>
      <div className={styles.glow} aria-hidden="true" />
      {props.loading && (
        <div className={styles.loader}>
          <Loader />
        </div>
      )}

      <main className={styles.content}>
        {props.showLogo && (
          <div className={styles.logoWrap}>
            <BookifullLogo className={styles.logo} />
          </div>
        )}

        <div className={classNames(props.showLogo && "text-center", styles.headingWrap)}>
          {props.heading && <h1 className={styles.heading}>{props.heading}</h1>}
        </div>

        <div className={styles.card}>{props.children}</div>
        {props.footerText && <div className={styles.footer}>{props.footerText}</div>}
        <div className={styles.legalFooter}>
          <PublicLegalFooter />
        </div>
      </main>
    </div>
  );
}
